"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = dispatchCustomEvent;
/**
 * @ignore
 * @typedef {object} CustomEvent
 * @property {object} CustomEvent.detail - data passed when initializing the event
 * @property {boolean} CustomEvent.bubbles - A boolean indicating whether or not the event bubbles up through the DOM
 */

/**
 * @ignore
 * @private
 * a wrapper for dispatching custom events for now
 *
 * @param {CustomEvent} customEvent - a native CustomEvent @see {@link https://developer.mozilla.org/en-US/docs/Web/API/CustomEventhttps://developer.mozilla.org/en-US/docs/Web/API/CustomEvent}
 */
function dispatchCustomEvent(customEvent) {
  var _window;
  (_window = window) === null || _window === void 0 || _window.dispatchEvent(customEvent);
}